import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

interface KeyboardHintsProps {
  onOpenShortcuts: () => void;
}

const HINTS_DISMISSED_KEY = 'ourss-keyboard-hints-dismissed';

export default function KeyboardHints({ onOpenShortcuts }: KeyboardHintsProps) {
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(HINTS_DISMISSED_KEY);
    setIsDismissed(dismissed === 'true');
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(HINTS_DISMISSED_KEY, 'true');
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <div className="keyboard-hints hidden lg:flex animate-slide-up">
      <div className="flex items-center gap-5 flex-1">
        <span>
          <kbd>j</kbd><kbd>k</kbd> move
        </span>
        <span>
          <kbd>Space</kbd> next page
        </span>
        <span>
          <kbd>Enter</kbd> open
        </span>
        <span>
          <kbd>l</kbd> like
        </span>
        <span>
          <kbd>⇧A</kbd> mark all read
        </span>
        <span>
          <kbd>/</kbd> search
        </span>
        <button
          onClick={onOpenShortcuts}
          className="text-accent-600 hover:underline underline-offset-2"
        >
          all shortcuts <kbd>?</kbd>
        </button>
      </div>
      <button
        onClick={handleDismiss}
        className="p-1 text-ink-muted hover:text-ink"
        aria-label="Dismiss hints"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
